export default "__VITE_ASSET__1620d866__"